import { JxtResourcesTypeEnum } from '@jooxter/utils';

export const JxtResourceIconInfo = {
  [JxtResourcesTypeEnum.BOOTH]: 'fa-phone',
  [JxtResourcesTypeEnum.BUBBLE]: 'fa-user-group',
  [JxtResourcesTypeEnum.VEHICLE]: 'fa-car',
  [JxtResourcesTypeEnum.DESK]: 'fa-desktop',
  [JxtResourcesTypeEnum.MEETING]: 'fa-users',
  [JxtResourcesTypeEnum.OTHER]: 'fa-building',
  [JxtResourcesTypeEnum.PARKING]: 'fa-parking',
  [JxtResourcesTypeEnum.VISIO]: 'fa-video',
};
